import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { BRACKET_CONNECTOR_W } from './knockoutBracket.constants'

export const getBracketConnectorStyles = (theme: Theme) =>
  StyleSheet.create({
    track: {
      width: BRACKET_CONNECTOR_W,
    },
    /** Bordered corners of an elbow (only the sided borders are given a width by the geometry). */
    elbowLine: {
      borderColor: theme.gray[200],
    },
    /** Filled straight segments (lead stub + 1→1 line). */
    fillLine: {
      backgroundColor: theme.gray[200],
    },
  })
